import React from 'react';
import { Link } from 'react-router-dom';
import {
  MapPin,
  Phone,
  Mail,
  Clock,
  Accessibility,
  CreditCard,
  ShoppingBag
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-br from-teal-500 to-emerald-600 p-2 rounded-lg">
                <div className="text-white font-bold text-lg">P</div>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">
                  Pharmacie Meyrin-Vergers
                </h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Votre pharmacie moderne et accessible dans le quartier Vergers de Meyrin, 
              face à l'hôpital. Personnel professionnel et conseils de qualité.
            </p>
            <div className="flex space-x-2">
              <div className="bg-teal-100 p-2 rounded-lg">
                <Accessibility className="h-4 w-4 text-teal-600" />
              </div>
              <div className="bg-teal-100 p-2 rounded-lg">
                <CreditCard className="h-4 w-4 text-teal-600" />
              </div>
              <div className="bg-teal-100 p-2 rounded-lg">
                <ShoppingBag className="h-4 w-4 text-teal-600" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-gray-600 hover:text-teal-600 transition-colors">
                Accueil
              </Link>
              <Link to="/about" className="block text-sm text-gray-600 hover:text-teal-600 transition-colors">
                À Propos
              </Link>
              <Link to="/services" className="block text-sm text-gray-600 hover:text-teal-600 transition-colors">
                Services
              </Link>
              <Link to="/reviews" className="block text-sm text-gray-600 hover:text-teal-600 transition-colors">
                Avis Clients
              </Link>
              <Link to="/contact" className="block text-sm text-gray-600 hover:text-teal-600 transition-colors">
                Contact
              </Link>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Nos Services
            </h4>
            <div className="space-y-2 text-sm text-gray-600">
              <div>Retrait en magasin</div>
              <div>Visite rapide</div>
              <div>Conseils personnalisés</div>
              <div>Livraison gratuite</div>
              <div>Paiement sans contact</div>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-teal-600 mt-0.5" />
                <div className="text-sm text-gray-600">
                  <div>Rue des Arpenteurs</div>
                  <div>1217 Meyrin-Vergers</div>
                  <div>Face à l'hôpital</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-teal-600" />
                <span className="text-sm text-gray-600">+41 22 987 59 17</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-teal-600" />
                <span className="text-sm text-gray-600">info@pharmacie-meyrin.ch</span>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="h-4 w-4 text-teal-600 mt-0.5" />
                <div className="text-sm text-gray-600">
                  <div>Lun-Ven: 8h00-19h00</div>
                  <div>Sam: 8h00-17h00</div>
                  <div>Dim: Fermé</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-black">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center text-center md:text-left gap-4">
            
            <p className="text-sm">
              © 2025 Pharmacie Meyrin-Vergers. All rights reserved.
            </p>

            <span className="text-sm">
              Developed and maintained with ❤️ by{" "}
              <strong>
                <a
                  href="https://ai.hridx.tech/"
                  className="text-teal-400 underline underline-offset-4"
                >
                  HridxAI...
                </a>
              </strong>
            </span>

          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;